import axios from 'axios';
import { Card, QuickbooksToken } from '../model/Entities';
import configuration from '../config/Configuration';

class QuickbooksApi {
    readonly url = configuration.quickbooksApi || '';

    create = async (card: Card): Promise<QuickbooksToken> => {
        const response = await axios.post<QuickbooksToken>(this.url + '/quickbooks/v4/payments/tokens', card);
        return response.data;
    };
}
const quickbooksApi: QuickbooksApi = new QuickbooksApi();
export default quickbooksApi;
